<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Donations" subTitle="History"></app-breadcrumb>
        
        <!-- statement -->
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <p><span class="h3">History</span> <br>(thank you for helping others with your donations, we appreciate you)</p>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped mt-2">
                        <thead class="bg-silver">
                            <tr v-if="countRecords">
                                <td colspan="5" class="bg-white p-1" style="border: 0px;">
                                    Showing 
                                    <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                                        <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                                    </select> 
                                    of {{countRecords.total}} records
                                </td>
                            </tr>
                            <tr>
                                <th>S/N</th>
                                <th>Donated Item</th>
                                <th>Qty</th>
                                <th>Beneficiary</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody v-if="myBeneficiaries">
                            <tr v-for="(beneficiary, i) in myBeneficiaries" :key="i">
                                <th>{{i+1}}.</th>
                                <td>
                                    <router-link :to="{ name: 'listItem', params: { id: beneficiary.itemId } }">
                                        {{beneficiary.item | capitalize}} <i class="far fa-share-square text-dark-green"></i>
                                    </router-link>
                                </td>
                                <td>{{beneficiary.qty}}</td>
                                <td>
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: beneficiary.handle} }" class="m-0">
                                        <i class="far fa-user text-dark-green"></i> 
                                        {{beneficiary.name | capitalize}}
                                    </router-link>
                                </td>
                                <td>{{beneficiary.time | moment("MMM D 'YY hh:mm A")}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { paginateRecords } from '@/store/dry'

import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "DonationHistory",
    data() {
        return {
            recordsLimit: 0,
        }
    },
    methods: {
        ...mapActions(['fetchDonationsHistory']),
        modifyLimit(limit) {
            this.recordsLimit = limit
        }
    },
    computed: {
        ...mapGetters(['donationsHistory']),
        myBeneficiaries() {
            if(this.donationsHistory && this.donationsHistory.length){
                return this.donationsHistory
            }
            return false
        },
        countRecords() {
            if(this.donationsHistory && this.donationsHistory.length){
                let resultObj = paginateRecords(this.donationsHistory, 9)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        },
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchDonationsHistory().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>